import { navigate } from "gatsby";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { SITE_URL } from "../../../../company/settings/metadata";
import { LANGUAGE } from "../../../../company/settings/translations";
import { getCodeLang } from "../Shared/Utils/getCodeLang";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation("language-selector");

  // useEffect(() => {
  //   // const linkElement = document.querySelector(`link[rel="alternate"][hreflang="${i18n.language}"]`);
  //   // if (linkElement) {
  //   //   alert("linkElement");
  //   // }
  // }, [i18n.language]);
  function handleLanguageChange(lang: LANGUAGE) {
    const linkElement = document.querySelector(
      `link[rel="alternate"][hreflang="${getCodeLang(lang)}"]`,
    );
    if (linkElement) {
      const hrefValue = linkElement.getAttribute("href");
      const slug = hrefValue?.split(SITE_URL)[1];
      // if (i18n.language === defaultLanguage && slug) {
      //   navigate(getSlugWithLang(slug, i18n.language));
      //   return;
      // }
      if (slug) {
        navigate(`/${slug}`);
        return;
      }
      navigate("/");
    }
  }

  return (
    <div className={`m-language-selector`}>
      <button
        className={`language-selector__button ${
          i18n.language === LANGUAGE.ES
            ? "language-selector__button--active"
            : "language-selector__button--no-active"
        }`}
        // disabled={true}
        onClick={() => handleLanguageChange(LANGUAGE.ES)}
      >
        es
      </button>
      <button
        className={`language-selector__button ${
          i18n.language === LANGUAGE.EN
            ? "language-selector__button--active"
            : "language-selector__button--no-active"
        }`}
        // disabled={true}
        onClick={() => handleLanguageChange(LANGUAGE.EN)}
      >
        en
      </button>
    </div>
  );
};

export default LanguageSelector;
